import { render } from "./DatabaseManage.vue?vue&type=template&id=74aa0538"
import script from "./DatabaseManage.vue?vue&type=script&lang=js"
export * from "./DatabaseManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__